import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
export default class Banner {
    constructor() {
        this.sections = document.querySelectorAll('.block-banner');
        this.ready();
    }

    ready() {
        if (this.sections.length > 0) {
            this.sections.forEach((section) => {
                this.slider = section.querySelector('.swiper');
                this.navigationNext = section.querySelector('.slider-button-next');
                this.navigationPrev = section.querySelector('.slider-button-prev');

                new Swiper(this.slider, {
                    modules: [Navigation, Pagination, Thumbs],
                    grabCursor: false,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    allowTouchMove: true,
                    navigation: {
                        nextEl: this.navigationNext,
                        prevEl: this.navigationPrev,
                    },
                });

            })
        }
    }
}

if (document.querySelector('.block-banner')) {
    new Banner();
}